import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("header", { class: "w-full px-8 py-4" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-lg text-black font-bold" }, " みんがく | スクールAI管理ページ ")
], -1)
const _hoisted_2 = { class: "flex flex-col items-center container mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "text-lg text-black font-bold mb-12" }, " 教室移動エラー対応ページ ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mb-12 text-sm text-gray-500 text-center" }, [
  /*#__PURE__*/_createTextVNode(" 教室移動のフローで不具合があった場合に使用します。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 対象のスクールを検索し、選択してください。 ")
], -1)
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 名前で検索 ")
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" スクールドキュメントIDで検索 ")
const _hoisted_10 = {
  key: 0,
  class: "mt-8 w-full max-w-2xl"
}
const _hoisted_11 = { class: "text-lg text-black font-bold mb-4" }
const _hoisted_12 = { class: "bg-blue-50 rounded-md border border-blue-200 p-4" }
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = { class: "text-sm text-gray-700" }
const _hoisted_15 = /*#__PURE__*/_createVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_16 = { class: "mt-4 pt-4 border-t border-blue-200 flex items-center justify-between" }
const _hoisted_17 = { class: "mt-4 pt-4 border-t border-blue-200" }
const _hoisted_18 = { class: "mt-4 pt-4 border-t border-blue-200 flex gap-4" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 重複を修正 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" サブコレクションの移動を修正 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 会話の教室IDを修正 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" ジャーナルの教室IDを修正 ")
const _hoisted_23 = {
  key: 1,
  class: "mt-8 w-full max-w-2xl flex flex-col gap-4"
}
const _hoisted_24 = { class: "flex items-center justify-between" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h3", { class: "text-lg text-black font-bold" }, "検索結果", -1)
const _hoisted_26 = { class: "bg-primary-100 rounded-md border border-primary-100" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "grid grid-cols-3 py-2 px-4 border-b border-gray-300" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-700 border-r border-gray-300 pr-4" }, " 選択 "),
  /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-700 border-r border-gray-300 px-4" }, " 学校名 "),
  /*#__PURE__*/_createVNode("div", { class: "text-sm font-medium text-gray-700 pl-4" }, " オーナー ")
], -1)
const _hoisted_28 = { class: "text-sm text-gray-700 border-r border-gray-300 pr-4 flex items-center" }
const _hoisted_29 = { class: "text-sm text-gray-700 border-r border-gray-300 px-4 flex items-center" }
const _hoisted_30 = {
  key: 0,
  class: "ml-2 text-xs text-blue-600"
}
const _hoisted_31 = { class: "text-sm text-gray-700 pl-4" }
const _hoisted_32 = {
  key: 2,
  class: "mt-8 w-full max-w-2xl flex flex-col items-center"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-50 border border-gray-200 rounded-md p-8 text-center" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 mb-3" }, [
    /*#__PURE__*/_createVNode("svg", {
      class: "w-12 h-12 mx-auto",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-500" }, " 結果がありません "),
  /*#__PURE__*/_createVNode("p", { class: "text-xs text-gray-400 mt-2" }, " 別のキーワードで検索してください ")
], -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" ホームへ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_SubCollectionResultModal = _resolveComponent("SubCollectionResultModal")
  const _component_DuplicationResultModal = _resolveComponent("DuplicationResultModal")
  const _component_ConversationResultModal = _resolveComponent("ConversationResultModal")
  const _component_JournalResultModal = _resolveComponent("JournalResultModal")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("main", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("section", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", null, [
            _createVNode(_component_m_text_field, {
              label: "学校名で検索（前方一致で部分検索可）",
              type: "text",
              value: _ctx.name,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_m_button, { onClick: _ctx.searchByName }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", null, [
            _createVNode(_component_m_text_field, {
              label: "スクールDocIdで検索（完全一致）",
              type: "text",
              value: _ctx.schoolDocId,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.schoolDocId = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_m_button, { onClick: _ctx.searchByDocId }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      (_ctx.selectedSchoolDocIds.length > 0)
        ? (_openBlock(), _createBlock("section", _hoisted_10, [
            _createVNode("h3", _hoisted_11, " 選択済みスクール（" + _toDisplayString(_ctx.selectedSchoolDocIds.length) + "件） ", 1),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedSchoolDocIds, (docId) => {
                  return (_openBlock(), _createBlock("div", {
                    key: docId,
                    class: "flex items-center gap-2 bg-white border border-blue-300 rounded-full px-3 py-1"
                  }, [
                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.schoolNameMap[docId] || docId), 1),
                    _createVNode("button", {
                      class: "text-gray-400 hover:text-red-500 transition-colors",
                      onClick: ($event: any) => (_ctx.removeSelectedSchool(docId))
                    }, [
                      _hoisted_15
                    ], 8, ["onClick"])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("button", {
                  class: "text-sm text-red-500 hover:text-red-700 transition-colors",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearAllSelected && _ctx.clearAllSelected(...args)))
                }, " すべてクリア ")
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_m_text_field, {
                  label: "認証トークン",
                  type: "password",
                  placeholder: "トークンを入力してください",
                  value: _ctx.authToken,
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.authToken = $event))
                }, null, 8, ["value"])
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_m_button, {
                  color: "primary-500",
                  disabled: !_ctx.authToken,
                  onClick: _ctx.fixStudentDuplications
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_m_button, {
                  color: "primary-500",
                  disabled: !_ctx.authToken,
                  onClick: _ctx.fixStudentSubCollectionTransfer
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_m_button, {
                  color: "primary-500",
                  disabled: !_ctx.authToken,
                  onClick: _ctx.fixStudentClassroomIdInConversations
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_m_button, {
                  color: "primary-500",
                  disabled: !_ctx.authToken,
                  onClick: _ctx.fixStudentJournalReflections
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.foundSchools.length)
        ? (_openBlock(), _createBlock("section", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("button", {
                class: "text-sm text-blue-600 hover:text-blue-800 transition-colors",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectAllSearchResults && _ctx.selectAllSearchResults(...args)))
              }, " すべて選択 ")
            ]),
            _createVNode("div", _hoisted_26, [
              _hoisted_27,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foundSchools, (school, i) => {
                return (_openBlock(), _createBlock("div", {
                  key: i,
                  class: "border-t border-gray-300"
                }, [
                  _createVNode("div", {
                    class: "grid grid-cols-3 py-2 px-4 transition-colors duration-300 hover:bg-white cursor-pointer",
                    onClick: ($event: any) => (_ctx.toggleSchoolSelection(school))
                  }, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("input", {
                        type: "checkbox",
                        checked: _ctx.isSelected(school),
                        class: "w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500",
                        onClick: _withModifiers(($event: any) => (_ctx.toggleSchoolSelection(school)), ["stop"])
                      }, null, 8, ["checked", "onClick"])
                    ]),
                    _createVNode("div", _hoisted_29, [
                      _createVNode("span", null, _toDisplayString(school.data.name), 1),
                      (_ctx.isSelected(school))
                        ? (_openBlock(), _createBlock("span", _hoisted_30, " ✓ "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_31, _toDisplayString(school.ownerName ?? ""), 1)
                  ], 8, ["onClick"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showNoResultsMessage)
        ? (_openBlock(), _createBlock("section", _hoisted_32, [
            _hoisted_33
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_m_button, {
        class: "mt-24",
        onClick: _ctx.moveToHome
      }, {
        default: _withCtx(() => [
          _hoisted_34
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.showSubCollectionResultModal)
      ? (_openBlock(), _createBlock(_component_SubCollectionResultModal, {
          key: 0,
          results: _ctx.subCollectionResults,
          "school-name-map": _ctx.schoolNameMap,
          onClose: _ctx.closeSubCollectionResultModal
        }, null, 8, ["results", "school-name-map", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showDuplicationResultModal)
      ? (_openBlock(), _createBlock(_component_DuplicationResultModal, {
          key: 1,
          results: _ctx.duplicationResults,
          "school-name-map": _ctx.schoolNameMap,
          onClose: _ctx.closeDuplicationResultModal
        }, null, 8, ["results", "school-name-map", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showConversationResultModal)
      ? (_openBlock(), _createBlock(_component_ConversationResultModal, {
          key: 2,
          results: _ctx.conversationResults,
          "school-name-map": _ctx.schoolNameMap,
          onClose: _ctx.closeConversationResultModal
        }, null, 8, ["results", "school-name-map", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showJournalResultModal)
      ? (_openBlock(), _createBlock(_component_JournalResultModal, {
          key: 3,
          results: _ctx.journalResults,
          "school-name-map": _ctx.schoolNameMap,
          onClose: _ctx.closeJournalResultModal
        }, null, 8, ["results", "school-name-map", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}